// The chart inputs of a rapid-association block, ported from RapidAssociation.ChartView
// (renderReactChart).
//
// The chart draws whichever of the three views the block is in, so the view travels with it: it is
// what decides the modes on offer and, in the scatter view, what is plotted at all.

import { getColorTheme, getFeatures, getModelValue } from '@aytm/app/stats/lib/stat-page'
import { isRType as calcIsRType, isTraitType as calcIsTraitType } from '@aytm/app/stats/page/components/lib/utils'
import PageGlobals from '@aytm/app/stats/lib/page/page-globals'

export const calcChartProps = ({
  id,
  questionKey,
  type,
  btnsType,
  format,
  answer,
  answerVariants,
  questionChartMode,
  chartMode,
  viewMode,
  zoomLevel,
  sortOrder,
  handlers = {}
} = {}) => ({
  questionId: id,
  questionKey,
  qType: type,
  btnsType,
  viewMode,
  chartMode,
  questionChartMode,
  globalChartMode: getModelValue('chartMode'),
  zoomLevel,
  globalZoomLevel: getModelValue('zoomLevel'),
  answer,
  answerVariants,
  sortOrder,
  // a question counting respondents reports them the way the report is read; anything else counts cases
  rType: calcIsRType({ type }) ? getModelValue('rType') : 'cases',
  format,
  isTraitType: calcIsTraitType({ format, type }),
  colorTheme: getColorTheme(),
  chartLegendMode: getModelValue('chartLegendMode'),
  confidenceLevel: getModelValue('confidenceLevel'),
  significanceLevel: getModelValue('significanceLevel'),
  confidenceLevels: PageGlobals.CONFIDENCE_LEVELS,
  features: getFeatures(),
  onChartModeChange: handlers.onChartModeChange,
  onZoomChange: handlers.onZoomChange,
  onChartReady: handlers.onChartReady
})
